module.exports = __webpack_public_path__ + "img/bef.d2180a2e.png";